import styled from 'styled-components';

export const ActionsCellStyled = styled.div`
  align-items: center;
  display: flex;
  height: 39px;

  button {
    padding: 0 5px;
  }

  button:has(.glyphicon-remove-sign) {
    margin-top: -7px;
  }
`;
